import { privateInstance, mapUrl } from "../configs";

export const preparationSlipApi = {
  //Slips
  async getPreparationSlips(params) {
    let req = "/inventory/api/preparationslip/";
    if (params) {
      req += "?";
      const params_array = [];
      if (params.take) params_array.push(`take=${params.take}`);
      req += params_array.join("&");
    }
    const res = await privateInstance.get(req);
    return res.data;
  },
  async postPreparationSlip(slip) {
    let url = "/inventory/api/preparationslip/";
    const res = await privateInstance.post(url, slip);
    return res.data;
  },
  async retrievePreparationSlip(id) {
    let url = `/inventory/api/preparationslip/${id}/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async patchPreparationSlip(id, slip) {
    let url = `/inventory/api/preparationslip/${id}/`;
    const res = await privateInstance.patch(url, slip);
    return res.data;
  },
  //Products
  async getPreparationSlipProducts(params) {
    let url = "/inventory/api/preparationslip/product/";

    if (params) {
      if (params.store) url += `?store=${params.store}/`;
    }

    const res = await privateInstance.get(mapUrl(url));
    return res.data;
  },
  async postPreparationSlipProduct(slip) {
    let url = "/inventory/api/preparationslip/product/";
    const res = await privateInstance.post(url, slip);
    return res.data;
  },
  async retrievePreparationSlipProduct(id) {
    let url = `/inventory/api/preparationslip/product/${id}/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async patchPreparationSlipProduct(id, slip) {
    let url = `/inventory/api/preparationslip/product/${id}/`;
    const res = await privateInstance.patch(url, slip);
    return res.data;
  },
  async deletePreparationSlipProduct(id) {
    let url = `/inventory/api/preparationslip/product/${id}/`;
    const res = await privateInstance.delete(url);
    return res.data;
  },
  //Direct production
  async postProduction(data) {
    const res = await privateInstance.post("/inventory/api/production/", data);
    return res.data;
  }
};
